import React, { useMemo } from 'react'
import Resx from '@/components/Resx'
import Icon from '@/components/Icon'

function getBgColor (bgColor) {
  return `bg-${bgColor}`
}

function getBorderColor (borderColor) {
  return `border-${borderColor}`
}

function getTextColor (textColor) {
  return `text-${textColor}`
}

function Card ({ bgColor, borderColor, textColor, headerText, icon, dataCy, ...props }) {
  const cardColorType = bgColor ? getBgColor(bgColor) : borderColor ? getBorderColor(borderColor) : ''
  const textColorType = textColor ? getTextColor(textColor) : ''

  const style = useMemo(() => `card mb-3 ${cardColorType} ${textColorType}`, [cardColorType, textColorType])
  const headerStyle = borderColor ? `card-header ${getBgColor(borderColor)}` : 'card-header'

  return <div data-cy={dataCy} className={style}>
    <div className={headerStyle}>{icon && <Icon name={icon} />}<b><Resx name={headerText} /></b></div>
    <div className='card-body'>
      {props.children}
    </div>
  </div>
}

export { Card }



// WEBPACK FOOTER //
// ./src/components/cards/card.js